import axios from 'axios';

export const getProjectKeywordRanks = ({
    cancelToken,
    idToken,
    params,
    projectId
}) => {
    const headers = {
        Authorization: 'Bearer ' + idToken,
        'X-From': location.href
    };
    return axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/v2/projects/${projectId}/keyword-ranks`,
        { headers, params, cancelToken }
    );
};

export const getProjectObservationKeywords = ({
    cancelToken,
    idToken,
    params,
    projectId
}) => {
    const headers = {
        Authorization: 'Bearer ' + idToken,
        'X-From': location.href
    };
    return axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/v2/projects/${projectId}/observation-keywords`,
        { headers, params, cancelToken }
    );
};

export const getProjectObservationKeywordsDownload = ({
    idToken,
    params,
    projectId
}) => {
    const headers = {
        Authorization: 'Bearer ' + idToken,
        'X-From': location.href
    };
    return axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/v2/projects/${projectId}/observation-keywords/download`,
        { headers, params, responseType: 'blob' }
    );
};

export const getProjectObservationKeywordMetricsSummary = ({
    cancelToken,
    idToken,
    keywordId,
    params,
    projectId
}) => {
    const headers = {
        Authorization: 'Bearer ' + idToken,
        'X-From': location.href
    };
    return axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/v2/projects/${projectId}/observation-keywords/${keywordId}/metrics-summary`,
        { headers, params, cancelToken }
    );
};

export const getProjectObservationKeywordMetricsTerm = ({
    cancelToken,
    idToken,
    keywordId,
    params,
    projectId
}) => {
    const headers = {
        Authorization: 'Bearer ' + idToken,
        'X-From': location.href
    };
    return axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/v2/projects/${projectId}/observation-keywords/${keywordId}/metrics-term`,
        { headers, params, cancelToken }
    );
};

export const getProjectObservationKeywordSummaries = ({
    cancelToken,
    idToken,
    keywordId,
    params,
    projectId
}) => {
    const headers = {
        Authorization: 'Bearer ' + idToken,
        'X-From': location.href
    };
    if (
        process.env.VUE_APP_ENV === 'local' ||
        process.env.VUE_APP_ENV === 'demo' ||
        process.env.VUE_APP_ENV === 'prototype'
    ) {
        headers['x-api-fake-when-id'] = Number(keywordId) % 30;
    }
    return axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/v2/projects/${projectId}/observation-keywords/${keywordId}/summaries`,
        { headers, params, cancelToken }
    );
};
